// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"TimingBar_mainDiv__7YI5n"};